import { instance } from 'utils/api';

export type SharedFile = {
  id: number;
  name: string;
  size: string;
  mime: string;
  updatedAt?: string;
};

export type SharedFolder = {
  id: number;
  name: string;
  updatedAt?: string;
  files: SharedFile[];
  children: SharedFolder[];
};

// GET /storage/folder/shared?patient_id=&folder_id= — bare array of folders
// shared with the calling doctor, hydrated with files + children(+files).
export const fetchSharedFolders = async (params: {
  patient_id: number | string;
  folder_id?: number | string;
}): Promise<SharedFolder[]> => {
  const res = await instance.get<SharedFolder[]>('storage/folder/shared', {
    params
  });

  return res.data || [];
};
